// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3ugNI","list":"PatternAutocomplete_list__2rnmk"};